import { defaultStatus } from "../../screen/constant/defaultStatus";
import {
  PRODUCT_ADD_REQUEST,
  PRODUCT_ADD_SUCCESS,
  PRODUCT_ADD_FAILURE,
  PRODUCT_EDIT_REQUEST,
  PRODUCT_EDIT_SUCCESS,
  PRODUCT_EDIT_FAILURE,
  PRODUCT_VIEW_REQUEST,
  PRODUCT_VIEW_SUCCESS,
  PRODUCT_VIEW_FAILURE,
  PRODUCT_VIEW_ALL_REQUEST,
  PRODUCT_VIEW_ALL_SUCCESS,
  PRODUCT_VIEW_ALL_FAILURE,
  PRODUCT_DELETE_REQUEST,
  PRODUCT_DELETE_SUCCESS,
  PRODUCT_DELETE_FAILURE,
  PRODUCT_RESET_STATE,
  PRODUCT_SEARCH_REQUEST,
  PRODUCT_SEARCH_SUCCESS,
  PRODUCT_SEARCH_FAILURE,
  PRODUCT_VIEW_BY_BRAND_ID_REQUEST,
  PRODUCT_VIEW_BY_BRAND_ID_SUCCESS,
  PRODUCT_VIEW_BY_BRAND_ID_FAILURE,
} from "./ProductTypes";

const initialState = {
  //Product
  addProduct: { ...defaultStatus },
  editProduct: { ...defaultStatus },
  deleteProduct: { ...defaultStatus },
  viewProduct: { ...defaultStatus },
  viewAllProducts: { ...defaultStatus },
  viewProductsByBrandId: { ...defaultStatus },
  viewAllSearchProducts: { ...defaultStatus },
};

const ProductReducer = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    //Product Add
    case PRODUCT_ADD_REQUEST:
      return {
        ...state,
        addProduct: { ...defaultStatus, inProgress: true, ...payload },
      };
    case PRODUCT_ADD_SUCCESS:
      return {
        ...state,
        addProduct: { ...defaultStatus, success: true, ...payload },
      };
    case PRODUCT_ADD_FAILURE:
      return {
        ...state,
        addProduct: {
          ...defaultStatus,
          error: true,
          errormessage: payload?.errormessage || null,
          ...payload,
        },
      };

    //Product Edit
    case PRODUCT_EDIT_REQUEST:
      return {
        ...state,
        editProduct: { ...defaultStatus, inProgress: true, ...payload },
      };
    case PRODUCT_EDIT_SUCCESS:
      return {
        ...state,
        editProduct: { ...defaultStatus, success: true, ...payload },
      };
    case PRODUCT_EDIT_FAILURE:
      return {
        ...state,
        editProduct: {
          ...defaultStatus,
          error: true,
          errormessage: payload?.errormessage || null,
          ...payload,
        },
      };

    //Product View
    case PRODUCT_VIEW_REQUEST:
      return {
        ...state,
        viewProduct: { ...defaultStatus, inProgress: true, ...payload },
      };
    case PRODUCT_VIEW_SUCCESS:
      return {
        ...state,
        viewProduct: { ...defaultStatus, success: true, ...payload },
      };
    case PRODUCT_VIEW_FAILURE:
      return {
        ...state,
        viewProduct: {
          ...defaultStatus,
          error: true,
          inProgress: true,
          errormessage: payload?.errormessage || null,
          ...payload,
        },
      };

    //Product View All
    case PRODUCT_VIEW_ALL_REQUEST:
      return {
        ...state,
        viewAllProducts: { ...defaultStatus, inProgress: true, ...payload },
      };
    case PRODUCT_VIEW_ALL_SUCCESS:
      return {
        ...state,
        viewAllProducts: { ...defaultStatus, success: true, data: payload },
      };
    case PRODUCT_VIEW_ALL_FAILURE:
      return {
        ...state,
        viewAllProducts: {
          ...defaultStatus,
          error: true,
          errormessage: payload?.errormessage || null,
        },
      };

    //Product View By Brand Id
    case PRODUCT_VIEW_BY_BRAND_ID_REQUEST:
      return {
        ...state,
        viewProductsByBrandId: {
          ...defaultStatus,
          inProgress: true,
          ...payload,
        },
      };
    case PRODUCT_VIEW_BY_BRAND_ID_SUCCESS:
      return {
        ...state,
        viewProductsByBrandId: {
          ...defaultStatus,
          success: true,
          data: payload,
        },
      };
    case PRODUCT_VIEW_BY_BRAND_ID_FAILURE:
      return {
        ...state,
        viewProductsByBrandId: {
          ...defaultStatus,
          error: true,
          errormessage: payload?.errormessage || null,
        },
      };

    //Product Search View All
    case PRODUCT_SEARCH_REQUEST:
      return {
        ...state,
        viewAllSearchProducts: {
          ...defaultStatus,
          inProgress: true,
          ...payload,
        },
      };
    case PRODUCT_SEARCH_SUCCESS:
      return {
        ...state,
        viewAllSearchProducts: {
          ...defaultStatus,
          success: true,
          data: payload,
        },
      };
    case PRODUCT_SEARCH_FAILURE:
      return {
        ...state,
        viewAllSearchProducts: {
          ...defaultStatus,
          error: true,
          errormessage: payload?.errormessage || null,
        },
      };

    //Product Delete
    case PRODUCT_DELETE_REQUEST:
      return {
        ...state,
        deleteProduct: { ...defaultStatus, inProgress: true, ...payload },
      };
    case PRODUCT_DELETE_SUCCESS:
      return {
        ...state,
        deleteProduct: { ...defaultStatus, success: true, ...payload },
      };
    case PRODUCT_DELETE_FAILURE:
      return {
        ...state,
        deleteProduct: {
          ...defaultStatus,
          error: true,
          errormessage: payload?.errormessage || null,
          ...payload,
        },
      };

    //Reset
    case PRODUCT_RESET_STATE:
      return {
        ...initialState,
      };

    default:
      return state;
  }
};

export default ProductReducer;
